import React from 'react';
import classNames from 'classnames';
import { Title } from '@patternfly/react-core';
var PageHeaderTitle = function (_a) {
    var className = _a.className, title = _a.title;
    var pageHeaderTitleClasses = classNames(className);
    return (React.createElement(Title, { headingLevel: "h1", size: "2xl", className: pageHeaderTitleClasses, "widget-type": "InsightsPageHeaderTitle" }, title));
};
export default PageHeaderTitle;
//# sourceMappingURL=PageHeaderTitle.js.map